import { connect } from 'react-redux';
import { toggleMap as toggleMapAction } from '../../store/map/slice';

import { SmallMap } from './SmallMap';

const mapDispatchToProps = (dispatch) => ({
  onClick: () => dispatch(toggleMapAction()),
});

const connector = connect(undefined, mapDispatchToProps);

export default connector(SmallMap);
